document.addEventListener('DOMContentLoaded', () => {
  /* =====================================================
     QUIZ CONFIG
  ===================================================== */

  const QUIZ_FLOW = {

    startQuestion: 'who_testing',

    questions: {

      /* =====================================================
         WHO TESTING
      ===================================================== */

      who_testing: {

        id: 'who_testing',

        type: 'single',

        title: 'Who are we testing?',

        description:
          'We use this to make sure the test we recommend matches your biology, not a stereotype. Every option here is treated equally.',

        options: [

          {
            id: 'male',
            label: 'Male',
            description: 'Solo, or with a partner',
            biology: 'male',
            next: 'male_goal'
          },

          {
            id: 'female',
            label: 'Female',
            description: 'Solo, or with a partner',
            biology: 'female',
            next: 'female_goal'
          },

          {
            id: 'male_couple',
            label: 'Male couple',
            description: 'Both partners with sperm',
            biology: 'mm',
            next: 'male_couple_goal'
          },

          {
            id: 'female_couple',
            label: 'Female couple',
            description: 'Both partners with eggs',
            biology: 'ff',
            next: 'female_couple_goal'
          },

          {
            id: 'trans_non_binary',
            label: 'Trans / non-binary',
            description: 'Preservation & fertility options',
            biology: 'tnb',
            next: 'trans_goal'
          }

        ]

      },

      /* =====================================================
         MALE GOAL
      ===================================================== */

      male_goal: {

        id: 'male_goal',

        type: 'single',

        title: 'What brings you here today?',

        description:
          'Pick the option closest to your situation. We will tailor what comes next, including which test we recommend.',

        options: [

          {
            id: 'starting',
            label: 'Just starting or about to start',
            description: '',
            journey: 'curious',
            next: 'first_name'
          },

          {
            id: 'actively_trying',
            label: 'Actively trying to conceive for a while',
            description: 'Trying for over 6 months, miscarriage, or IVF that did not work',
            journey: 'pain',
            next: 'who_testing_today'
          },

          {
            id: 'planning_future',
            label: 'Planning for a family in the future',
            description: 'Not in a rush, but want to know where I stand',
            journey: 'optimisation',
            next: 'who_testing_today'
          },

          {
            id: 'curious',
            label: 'Just curious about my fertility health',
            description: 'No specific concern, want a baseline',
            journey: 'curious',
            next: 'first_name'
          },

          {
            id: 'preserving',
            label: 'Preserving fertility before something',
            description: 'Cancer treatment, surgery, military deployment, TRT',
            journey: 'pressure',
            pressureType:'hrt',
            next: 'first_name'
          },

          {
            id: 'vasectomy',
            label: 'I had a vasectomy',
            description: 'Confirm it worked, or that a reversal worked',
            journey: 'vasectomy',
            next: 'first_name'
          }

        ]

      },

      /* =====================================================
         FEMALE GOAL
      ===================================================== */

      female_goal: {

        id: 'female_goal',

        type: 'single',

        title:
          'What brings you here today?',

        description:
          'Pick the option closest to your situation. We will tailor what comes next, including which test we recommend.',

        options: [

          {
            id: 'trying_to_conceive',
            label: 'Actively trying to conceive for a while',
            description: 'Trying for over 6 months, miscarriage, or IVF that did not work ',
            journey: 'pain',
            next: 'who_testing_today'
          },

          {
            id: 'planning_family',
            label: 'Planning for a family in the future',
            description: 'Not in a rush, but want to know where I stand',
            journey: 'optimisation',
            next: 'who_testing_today'
          },

          {
            id: 'understand_fertility',
            label: 'I want to understand where I stand',
            description: 'No specific concern, want a hormonal baseline',
            journey: 'curious',
            next: 'first_name'
          },

          {
            id: 'preserving_fertility',
            label: 'Preserving fertility before something',
            description: 'Cancer treatment, surgery, military deployment, TRT',
            journey: 'pressure',
            pressureType:'hrt',
            next: 'first_name'
          },

          {
            id: 'going_through_ivf',
            label: 'I am going through IVF',
            description: 'Already in the IVF process and want a fuller picture',
            journey: 'pain',
            next: 'first_name'
          }

        ]

      },

      /* =====================================================
         MALE COUPLE GOAL
      ===================================================== */

      male_couple_goal: {

        id: 'male_couple_goal',

        type: 'single',

        title:
          'What brings you here today?',

        description:
          'Pick the option closest to your situation. We will tailor what comes next, including which test we recommend.',

        options: [

          {
            id: 'planning_child',
            label: 'We are planning to have a child',
            description: 'Surrogacy, adoption, or just deciding',
            journey: 'optimisation',
            next: 'who_testing_today'
          },

          {
            id: 'understand_fertility',
            label: 'We want to understand our fertility',
            description: 'Either of us, or both',
            journey: 'curious',
            next: 'first_name'
          },

          {
            id: 'preserving_fertility',
            label: 'Preserving fertility before something',
            description: 'Treatment, transition, or other reason',
            journey: 'pressure',
            pressureType:'hrt',
            next: 'first_name'
          }

        ]

      },

      /* =====================================================
         FEMALE COUPLE GOAL
      ===================================================== */

      female_couple_goal: {

        id: 'female_couple_goal',

        type: 'single',

        title:
          'What brings you here today?',

        description:
          'Pick the option closest to your situation. We will tailor what comes next, including which test we recommend.',

        options: [

          {
            id: 'trying_with_donor_sperm',
            label: 'We are trying to conceive with donor sperm',
            description: '',
            journey: 'pain',
            next: 'who_testing_today'
          },

          {
            id: 'planning_to_conceive',
            label: 'We are planning to conceive',
            description: 'Deciding who carries, exploring options',
            journey: 'optimisation',
            next: 'who_testing_today'
          },

          {
            id: 'understand_fertility',
            label: 'We want to understand our fertility',
            description: 'Either or both of us',
            journey: 'curious',
            next: 'first_name'
          },

          {
            id: 'test_donor_sample',
            label: 'We want to test the donor sample',
            description: 'Quality check before use',
            journey: 'curious',
            next: 'first_name'
          }

        ]

      },

      /* =====================================================
         TRANS FLOW
      ===================================================== */

      trans_goal: {

        id: 'trans_goal',

        type: 'single',

        title:
          'What brings you here today?',

        description:
          'Pick the option closest to your situation. We will tailor what comes next, including which test we recommend.',

        options: [

          {
            id: 'preserve_before_hrt',
            label: 'Preserving fertility before HRT',
            description: 'Banking before transition begins',
            journey: 'pressure',
            pressureType: 'hrt',
            next: 'first_name'
          },

          {
            id: 'on_hrt_preserve',
            label: 'I am on HRT and want to preserve what is possible',
            description: 'Already started, want to understand options',
            journey: 'pressure',
            pressureType: 'hrt_already',
            next: 'first_name'
          },

          {
            id: 'understand_current_status',
            label: 'I want to understand my current status',
            description: '',
            journey: 'curious',
            next: 'first_name'
          },

          {
            id: 'partner_planning_child',
            label: 'My partner and I are planning a child',
            description: '',
            journey: 'optimisation',
            next: 'who_testing_today'
          },

          {
            id: 'exploring_options',
            label: 'I am exploring my options',
            description: '',
            journey: 'curious',
            next: 'first_name'
          }

        ]

      },

      /* =====================================================
         WHO TESTING TODAY
      ===================================================== */

      who_testing_today: {

        id: 'who_testing_today',

        type: 'single',

        title:
          'Who is testing today?',

        description:
          'Pick the option closest to your situation. We will tailor what comes next, including which test we recommend.',

        options: [

          {
            id: 'just_me',
            label: 'Just me for now',
            description: '',
            partnerScope: 'just_me',
            next: 'first_name'
          },

          {
            id: 'me_and_partner',
            label: 'Me and my partner',
            description: '',
            partnerScope: 'both',
            next: 'first_name'
          },

          {
            id: 'not_sure_show_both',
            label: 'Not sure yet — show me both',
            description: '',
            partnerScope: 'show_both',
            next: 'first_name'
          }

        ]

      },

      /* =====================================================
         FIRST NAME
      ===================================================== */

      first_name: {

        id: 'first_name',

        type: 'input',

        title:
          'What should we call you?',

        description:
          'This helps personalize your results.',

        field: 'first_name',

        placeholder:
          'Enter your first name here',

        next: 'age'

      },

      /* =====================================================
         AGE
      ===================================================== */

      age: {

        id: 'age',

        type: 'single',

        title:
          'How old are you?',

        description:
          'Age helps us tailor recommendations to your fertility window and life stage.',

      options: [
  {
    id: 'under_30',
    label: 'Under 30'
  },

  {
    id: '30_34',
    label: '30 – 34'
  },

  {
    id: '35_39',
    label: '35 – 39'
  },

  {
    id: '40_44',
    label: '40 – 44'
  },

  {
    id: '45_49',
    label: '45 – 49'
  },

  {
    id: '50_plus',
    label: '50+'
  }
],


        conditionalNext: [
          { if: { journey: 'pain' }, goTo: 'history' },
          { if: { journey:'pressure', pressureType: 'hrt'}, goTo: 'preserving_before' },
          { if: { journey:'pressure', pressureType:'hrt_already' }, goTo: 'hrt_start_time' },
          { if: { journey: 'vasectomy' }, goTo: 'vasectomy_type' }
        ],

        next: 'lifestyle'

      },

      /* =====================================================
         HISTORY
      ===================================================== */

      history: {

        id: 'history',

        type: 'single',

        title:
          'What have you been through?',

        description:
          'Pick all that fit. We weight this above everything else.',

       options: [
  {
    id: 'trying12',
    label: 'We have been trying for more than a year',
    next:'lifestyle'
  },

  {
    id: 'miscarriage',
    label: 'We have had a miscarriage or pregnancy loss',
    next:'lifestyle'
  },

  {
    id: 'failed_ivf',
    label: 'We have been through IVF that did not work',
    next:'lifestyle',
  },

  {
    id: 'health',
    label: 'I have a known health factor (varicocele, infection, prior abnormal result)',
    next:'healthDetail'
  },

  {
    id: 'none',
    label: 'None of these — we are just starting to test',
    next:'lifestyle'
  }
]

      },

      /* =====================================================
         HEALTH DETAIL
      ===================================================== */

      healthDetail: {

        id: 'healthDetail',

        type: 'multi_select',

        title:
          'Which conditions apply?',

        description:
          'Pick all that apply.',

        next:
          'lifestyle',

        options: [

          {
            id: 'varicocele',
            label: 'Varicocele'
          },

          {
            id: 'infection',
            label: 'Past infection'
          },

          {
            id: 'priorabnormal',
            label: 'Abnormal semen analysis'
          },

          {
            id: 'surgery',
            label: 'Surgery or injury'
          },

          {
            id: 'none',
            label: 'None'
          }

        ]

      },


      preserving_before:{
  id: 'preserving_before',
  title: 'What are you preserving before?',
  description: 'This determines how urgent the next step is, and what kit we send.',
  type: 'single',
  next: 'treatment_start_timeline',

  options: [
    {
      id: 'finasteride',
      label: 'Finasteride or dutasteride',
      description: 'Chemotherapy or radiation'
    },

    {
      id: 'hormone_therapy',
      label: 'Hormone therapy / gender affirmation'
    },

    {
      id: 'trt',
      label: 'Starting TRT'
    },

    {
      id: 'vasectomy',
      label: 'A vasectomy I am planning'
    },

    {
      id: 'military',
      label: 'Military deployment or high-risk job'
    },

    {
      id: 'something_else',
      label: 'Something else'
    }
  ]
},

treatment_start_timeline:{
  id: 'treatment_start_timeline',
title: 'When does it start?',
  description: 'Earlier is always better. Banking before treatment, surgery, or therapy gives the most reliable preservation.',
  type: 'single',
  next: 'coverage_question',

  options: [
    {
      id: 'this_week',
      label: 'This week'
    },

    {
      id: 'within_month',
      label: 'Within a month'
    },

    {
      id: 'few_months',
      label: 'In a few months'
    },

    {
      id: 'not_sure',
      label: 'I am not sure yet'
    }
  ]
},

hrt_start_time:{
  id: 'hrt_start_time',
  title: 'When did you start HRT?',
  description: 'Earlier is always better. Banking before treatment, surgery, or therapy gives the most reliable preservation.',
  type: 'single',
  next: 'coverage_question',

  options: [
    {
      id: 'less_than_6_months',
      label: 'Less than 6 months'
    },

    {
      id: '6_to_12_months',
      label: '6 to 12 months'
    },

    {
      id: 'over_a_year',
      label: 'Over a year'
    }
  ]
},

      /* =====================================================
         LIFESTYLE
      ===================================================== */

      lifestyle: {

        id: 'lifestyle',

        type: 'multi_select',

        title:
          'Lifestyle factors',

        description:
          'Pick all that apply.',

        next:
          'medications',

        options: [

          {
            id: 'smoke',
            label: 'Smoking'
          },

          {
            id: 'alcohol',
            label: 'Heavy drinking'
          },

          {
            id: 'drugs',
            label: 'Drug usage'
          },

          {
            id: 'heat',
            label: 'Heat exposure'
          },

          {
            id: 'none',
            label: 'None'
          }

        ]

      },

      /* =====================================================
         MEDICATIONS
      ===================================================== */

      medications: {

        id: 'medications',

        type: 'multi_select',

        title:
          'Are you taking any of these?',

        description:
          'Pick all that apply.',

        next:
          'coverage_question',

        options: [

          {
            id: 'trt',
            label: 'Testosterone replacement'
          },

          {
            id: 'finasteride',
            label: 'Finasteride'
          },

          {
            id: 'ssri',
            label: 'SSRIs'
          },

          {
            id: 'chemo',
            label: 'Chemotherapy'
          },

          {
            id: 'none_meds',
            label: 'None'
          }

        ]

      },


      /* =====================================================
         Vasectomy_Status
      ===================================================== */

  vasectomy_type: {
  id: 'vasectomy_type',
  title: 'Which one?',
  description: 'Both tests are clinic-grade and clinician-reviewed. Results in 5 working days',
  type: 'single',
  next:'coverage_question',

  options: [
    {
      id: 'pvsa',
      label: 'I had a vasectomy',
      description: 'Confirm it worked'
    },

    {
      id: 'pvsa_reversal',
      label: 'I had a reversal',
      description: 'Confirm it worked'
    }
  ]
},


      /* =====================================================
         COVERAGE
      ===================================================== */

      coverage_question: {

        id: 'coverage_question',

        type: 'single',

        title:
          'How are you covering this?',

        description:
          'Choose one option.',

        options: [

   {
    id: 'paying_out_of_pocket',
    label: 'Paying out of pocket',
    next:'email_capture'
  },

  {
    id: 'progyny',
    label: 'Progyny',
    description: 'Through my employer',
    next:'email_capture'
  },

  {
    id: 'carrot_fertility',
    label: 'Carrot Fertility',
    description: 'Through my employer',
    next:'email_capture'
  },

  {
    id: 'maven_clinic',
    label: 'Maven Clinic',
    description: 'Through my employer',
    next:'email_capture'
  },

  {
    id: 'win_fertility',
    label: 'WIN Fertility',
    description: 'Through my employer',
    next:'email_capture'
  },

  {
    id: 'stork_club',
    label: 'Stork Club',
    description: 'Through my employer',
    next:'email_capture'
  },

  {
    id: 'hsa_fsa',
    label: 'HSA or FSA',
    description: 'Tax-advantaged',
    next:'email_capture'
  },

  {
    id: 'insurance_unsure',
    label: 'I have insurance, not sure about fertility benefits',
    next:'email_capture'
  },

 

]

      },

      /* =====================================================
         EMAIL
      ===================================================== */

      email_capture: {

        id: 'email_capture',

        type: 'input',

        title:
          'Where should we send your recommendation?',

        description:
          'Enter your email address.',

        field:
          'email',

        placeholder:
          'Enter your email',

        next:
          'result'

      }

    }

  };

  /* =====================================================
     STATE
  ===================================================== */

  const state = {

    currentQuestionId:
      QUIZ_FLOW.startQuestion,

    selectedOptionId: null,

    history: [],

    answers: {},

    cart:[]

  };

  /* =====================================================
     ELEMENTS
  ===================================================== */

  const elements = {

    title:
      document.querySelector('[data-rq-title]'),

    description:
      document.querySelector('[data-rq-description]'),

    options:
      document.querySelector('[data-rq-options]'),

    nextButton:
      document.querySelector('[data-rq-next]'),

    backButton:
      document.querySelector('[data-rq-back]'),

    progressBar:
      document.querySelector('[data-rq-progress]'),

    progressValue:
      document.querySelector('[data-rq-progress-value]')

  };


/* =========================================
   BUILD PRODUCTS OBJECT
========================================= */
async function fetchAllProducts() {

  let products = [];
  let page = 1;

  while (true) {

    const res =
      await fetch(
        `/collections/all/products.json?limit=250&page=${page}`
      );

    const data =
      await res.json();

    if (!data.products.length) {
      break;
    }

    products =
      products.concat(data.products);

    page++;

  }

  return products;

}

/* =========================================
   PRODUCT HANDLE → QUIZ KEY MAP
========================================= */

const PRODUCT_KEY_MAP = {

  'semen-analysis-and-dna-fragmentation-test-kit':
    'dna_frag',

  'full-female-blood-panel':
    'female_panel',

  'sapyen-complete-analysis':
    'complete',

  'sapyen-at-home-male-fertility-analysis-kit':
    'core',

  'vasectomy-test':
    'pvsa',

  'vasectomy-reversal':
    'pvsa_reversal'

};

/* =========================================
   STATIC CONTENT
========================================= */

const PRODUCT_CONTENT = {

  dna_frag: {

    shortTitle:
      'Know where you stand today with DNA Fragmentation Test',

    description:
      'Includes standard semen analysis plus DNA Fragmentation to identify DNA issues that impact fertility and pregnancy.',

    why:
      'Your profile suggests possible sperm quality and DNA integrity issues that routine semen testing may not fully detect.',

    comparePrice:
      500,

    features: [
      'Semen Analysis',
      'DNA Fragmentation (DFI)',
      'Motility + morphology'
    ]

  },

  female_panel: {

    shortTitle:
      'Know where you stand with Full Female Blood Panel',

    description:
      'Includes AMH, FSH, LH, estradiol, testosterone and prolactin.',

    why:
      'A complete hormonal picture is essential for understanding fertility timing and reserve.',

    comparePrice:
      250,

    features: [
      'AMH',
      'FSH and LH',
      'Estradiol'
    ]

  },

  complete: {

    shortTitle:
      'Know where you stand with Complete fertility test',

    description:
      'Full panel including DNA fragmentation and hormones.',

    why:
      'Your history indicates a comprehensive panel is needed.',

    comparePrice:
      2000,

    features: [
      'Semen Analysis',
      'DNA Fragmentation',
      'Hormone Panel'
    ]

  },

  core: {

    shortTitle:
      'Know where you stand with  Core semen analysis',

    description:
      'Standard semen analysis covering count, motility, and morphology.',

    why:
      'A solid starting point for understanding your baseline fertility.',

    comparePrice:
      250,

    features: [
      'Sperm count',
      'Motility',
      'Morphology'
    ]

  },

  pvsa: {

    shortTitle:
      'Post-vasectomy sperm analysis',

    description:
      'Confirms your vasectomy was successful.',

    why:
      'Recommended to verify the outcome of your vasectomy.',

    comparePrice:
      150,

    features: [
      'Sperm count confirmation',
      'Motility check'
    ]

  },

  pvsa_reversal: {

    shortTitle:
      'Post-reversal sperm analysis',

    description:
      'Confirms your vasectomy reversal was successful.',

    why:
      'Recommended to verify sperm are present after reversal.',

    comparePrice:
      150,

    features: [
      'Sperm count',
      'Motility',
      'Morphology'
    ]

  }

};
/* =========================================
   BUILD PRODUCTS
========================================= */

let PRODUCTS = {};

async function buildProductsObject() {

  const allProducts =
    await fetchAllProducts();


  const currency =
    Shopify.currency.active;

  const country =
    Shopify.country;

  const TRANSFORMED_PRODUCTS = {};

  allProducts.forEach(product => {

    const mappedKey =
      PRODUCT_KEY_MAP[
        product.handle
      ];

    if (!mappedKey) return;

    const firstVariant =
      product.variants?.[0];

    if (!firstVariant) return;

    TRANSFORMED_PRODUCTS[mappedKey] = {

      id:
        mappedKey,

      name:
        product.title,

      product_id:
        String(firstVariant.id),

      shortTitle:
        PRODUCT_CONTENT[mappedKey]
          ?.shortTitle || '',

      description:
        product.body_html || '',

      why:
        PRODUCT_CONTENT[mappedKey]
          ?.why || '',

      price:
        `${new Intl.NumberFormat(
          undefined,
          {
            style: 'currency',
            currency,
            currencyDisplay: 'narrowSymbol'
          }
        ).format(firstVariant.price)}`,

     comparePrice:
  firstVariant.compare_at_price ||
  PRODUCT_CONTENT[mappedKey]?.comparePrice
    ? `${new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
      }).format(
        firstVariant.compare_at_price ||
        PRODUCT_CONTENT[mappedKey]?.comparePrice
      )}`
    : '',

      image:
        product.images?.[0]?.src || '',

      features:
        PRODUCT_CONTENT[mappedKey]
          ?.features || [],

      currency,
      country

    };

  });

  PRODUCTS = TRANSFORMED_PRODUCTS;


  return PRODUCTS;

}

buildProductsObject();



  /* =====================================================
     HELPERS
  ===================================================== */

    const AGE_BAND_ORDER = ['under_30', '30_34', '35_39', '40_44', '45_49', '50_plus'];

    function is35Plus(ageBand) {
        return ['35_39', '40_44', '45_49', '50_plus'].includes(ageBand);
    }


  function getQuestion(questionId) {

    return QUIZ_FLOW.questions[
      questionId
    ];

  }

  function showScreen(id) {

    document
      .querySelectorAll('#rq-app > *')
      .forEach(screen => {

        screen.style.display = 'none';

      });

    const target =
      document.getElementById(id);

    if (target) {

      target.style.display = 'block';

    }

  }

  /* =====================================================
     AGE HELPERS
  ===================================================== */

  function ageBand(age) {

    return age;

  }

  function inAgeBand(age, band) {

    const n = +age;

    if (band === '35+') {
      return n >= 35;
    }

    return false;

  }

  /* =====================================================
     DFI
  ===================================================== */

  const DFI_AGE_BASELINE = {

    'under_30': 17,
    '30_34': 18,
    '35_39': 20,
    '40_44': 23,
    '45_49': 23,
    '50_plus': 26

  };


  const DFI_MODIFIERS = {

    smoke: 9,
    alcohol: 2,
    overweight:4,
    heat: 9,
    drugs: 5,
    varicocele: 13,
    infection: 6,
    priorabnormal: 7,
    surgery: 7,
    hernia:4,
    elsehealth:5,
    miscarriage: 6,
    failed_ivf: 8,
    trying12:4,
    finasteride: 4,
    trt: 25,
    chemo: 20,
    ssri: 3,
    hormone_therapy:20,

  };

  function getEstimatedDFI(a) {

    let dfi =
      DFI_AGE_BASELINE[
        ageBand(a.age)
      ] || 17;

    [
      ...(a.lifestyle || []),
      ...(a.healthDetail || []),
      ...(a.history || []),
      ...(a.medications || [])
    ].forEach(key => {

      if (DFI_MODIFIERS[key]) {
        dfi += DFI_MODIFIERS[key];
      }

    });

    return Math.min(dfi, 75);

  }

  function getDFIBand(dfi) {

    if (dfi < 15) return 'optimal';
    if (dfi < 20) return 'typical';
    if (dfi < 25) return 'mild';
    if (dfi < 35) return 'significant';

    return 'critical';

  }

  /* =====================================================
   AMH
===================================================== */

const AMH_AGE_MEDIAN = {

  'under_30': 3.5,
  '30_34': 2.2,
  '35_39': 1.3,
  '40_44': 0.6,
  '45_49': 0.3,
  '50_plus': 0.3

};

const AMH_MODIFIERS = {

  smoke: -0.4,
  alcohol: -0.1,
  overweight: -0.2,

  failed_ivf: -0.3,
  miscarriage: -0.15

};

const AMH_BAND_LABELS = {

  high: 'HIGH RESERVE',
  strong: 'STRONG RESERVE',
  typical: 'TYPICAL RANGE',
  diminished: 'DIMINISHED',
  low: 'CRITICAL'

};

function getEstimatedAMH(a) {

  let amh =
    AMH_AGE_MEDIAN[
      ageBand(a.age)
    ] || 2.2;

  [
    ...(a.lifestyle || []),
    ...(a.history || [])
  ].forEach(key => {

    if (AMH_MODIFIERS[key]) {

      amh += AMH_MODIFIERS[key];

    }

  });

  return Math.max(
    Number(amh.toFixed(2)),
    0.1
  );

}

function getAMHBand(amh) {

  if (amh >= 3.5) {
    return 'high';
  }

  if (amh >= 2.0) {
    return 'strong';
  }

  if (amh >= 1.2) {
    return 'typical';
  }

  if (amh >= 0.5) {
    return 'diminished';
  }

  return 'low';

}

  /* =====================================================
     PRODUCTS
  ===================================================== */

function getPrimaryProduct(a) {
  const biology      = a.biology;
  const journey      = a.journey;
  const ageBand      = a.age;
  const history      = a.history;          // now a string, not array
  const lifestyle    = a.lifestyle    || [];
  const healthDetail = a.healthDetail || [];
  const medications  = a.medications  || [];

  if (biology === 'female' || biology === 'ff') return 'female_panel';

  if (journey === 'vasectomy') {
    if (a.vasectomy_type === 'pvsa_reversal') return 'pvsa_reversal';
    return 'pvsa';
  }

  if (medications.includes('chemo')) return 'complete';

  if (biology === 'male') {
    if (history === 'failed_ivf') return 'complete';

    const hasHealthFactor = healthDetail.some(h => h !== 'none');

    if (history === 'miscarriage' && is35Plus(ageBand)) return 'complete';
    if (history === 'miscarriage' && hasHealthFactor)   return 'complete';

    const lifestyleCount = lifestyle.filter(x => x !== 'none').length;
    if (history === 'trying12' && is35Plus(ageBand) && lifestyleCount >= 2) return 'complete';
    if (history === 'trying12' && hasHealthFactor) return 'complete';

    // Core: curious + under 30 + no lifestyle + no meds
    const noLifestyle   = lifestyle.every(x => x === 'none')       || lifestyle.length === 0;
    const noMedications = medications.every(x => x === 'none_meds') || medications.length === 0;
    if (journey === 'curious' && ageBand === 'under_30' && noLifestyle && noMedications) return 'core';
  }

  return 'dna_frag';
}

  function getPartnerProduct(a) {

  const hasPartner =
    a.partnerScope === 'both' ||
    a.partnerScope === 'show_both';

  if (!hasPartner) return null;

  const allowFemalePanel = Shopify.country === 'GB';

  // PATH 01 — Male → partner gets Female Panel
   if (a.biology === 'male') {
    return allowFemalePanel
      ? 'female_panel'
      : null;
  }

  // PATH 02 — Female → partner gets DNA Fragmentation
  if (a.biology === 'female') return 'dna_frag';

  // PATH 03 — Male couple → partner gets DNA Fragmentation
  if (a.biology === 'mm') return 'dna_frag';

  // PATH 04 — Female couple → partner gets Female Panel
  if (a.biology === 'ff') {
    return allowFemalePanel
      ? 'female_panel'
      : null;
  }

  // PATH 05 — Trans/non-binary → partner gets Female Panel
  // only reachable via partner_planning_child (optimisation journey)
   if (a.biology === 'tnb') {
    return allowFemalePanel
      ? 'female_panel'
      : null;
  }

  return null;

}


function getAlternateProducts(a) {

  const primary = getPrimaryProduct(a);

  // PVSA and PVSA Reversal are transactional — no alternates
  if (primary === 'pvsa' || primary === 'pvsa_reversal') return [];

  // Female / Female couple — only one product in catalogue
  if (a.biology === 'female' || a.biology === 'ff') return [];

  // Male, Male couple, Trans/non-binary — show all male products except primary
  const MALE_PRODUCTS = ['core', 'dna_frag', 'complete'];

  return MALE_PRODUCTS.filter(p => p !== primary);

}



  function getShowCryo(a) {

    const allowedCountries = ['US', 'GB'];

    if (!allowedCountries.includes(Shopify.country)) {
          return false;
    }


    if (
      a.biology === 'female' ||
      a.biology === 'ff'
    ) {

      return false;

    }

    if (
      a.journey === 'vasectomy'
    ) {

      return false;

    }

    return true;

  }

  /* =====================================================
     ROUTING
  ===================================================== */



  function resolveNext(currentId, state) {

  const q =
    QUIZ_FLOW.questions[
      currentId
    ];

  if (!q) return null;

  const a =
    state.answers || {};

  let nextTarget = null;

  /* =========================
     OPTION LEVEL NEXT
  ========================= */

  if (
    q.type === 'single' &&
    a._lastSelectedOption
  ) {

    const opt =
      (q.options || []).find(
        o =>
          o.id ===
          a._lastSelectedOption
      );

    if (opt?.next) {

      nextTarget =
        opt.next;

    }

  }

  /* =========================
     CONDITIONAL NEXT
  ========================= */

  if (!nextTarget && q.conditionalNext) {

    for (const rule of q.conditionalNext) {

      if (
        matchesRule(
          rule.if,
          a
        )
      ) {

        nextTarget =
          rule.goTo;

        break;

      }

    }

  }

  /* =========================
     DEFAULT NEXT
  ========================= */

  if (!nextTarget) {

    nextTarget =
      q.next;

  }

  /* =========================
     SKIP INSURANCE PAGE
  ========================= */

  if (
    nextTarget ===
      'coverage_question' &&
    shouldSkipInsurance()
  ) {

    nextTarget =
      'email_capture';

  }

  return resolveSkip(
    nextTarget,
    state
  );

}

  function resolveSkip(targetId, state) {

    if (!targetId) return null;

    const q =
      QUIZ_FLOW.questions[
        targetId
      ];

    if (
      !q ||
      !q.skip ||
      !q.skip.if
    ) {

      return targetId;

    }

    if (
      matchesRule(
        q.skip.if,
        state.answers || {}
      )
    ) {

      return resolveSkip(
        q.next,
        state
      );

    }

    return targetId;

  }

  function matchesRule(rule, a) {
  if (!rule) return false;
  if (rule.journey     && a.journey     !== rule.journey)     return false;
  if (rule.biology     && a.biology     !== rule.biology)     return false;
  if (rule.partnerScope && a.partnerScope !== rule.partnerScope) return false;
  if (rule.pressureType && a.pressureType !== rule.pressureType) return false; // add this
  if (rule.selectionIncludes) {
    const sel = a._lastMultiSelection || [];
    if (!sel.includes(rule.selectionIncludes)) return false;
  }
  return true;
}


/* =====================================================
   PROGRESS
===================================================== */

const QUESTION_ORDER = [

  'who_testing',

  'male_goal',
  'female_goal',
  'male_couple_goal',
  'female_couple_goal',
  'trans_goal',

  'who_testing_today',

  'first_name',
  'age',

  'history',
  'healthDetail',

  'preserving_before',
  'treatment_start_timeline',
  'hrt_start_time',

  'lifestyle',
  'medications',

  'vasectomy_type',

  'coverage_question',
  'email_capture'

];

function updateProgress(questionId) {

  const currentIndex =
    QUESTION_ORDER.indexOf(questionId);

  if (currentIndex === -1) return;

  const totalQuestions =
    QUESTION_ORDER.length - 1;

  let progress =
    (currentIndex / totalQuestions) * 99;

  progress = Math.max(
    0,
    Math.min(progress, 99)
  );

  if (elements.progressBar) {

    elements.progressBar.style.width =
      `${progress}%`;

  }

  if (elements.progressValue) {

    elements.progressValue.textContent =
      `${Math.round(progress)}%`;

  }

}

  /* =====================================================
     RENDER QUESTION
  ===================================================== */

  function renderQuestion(questionId) {

    const question =
      getQuestion(questionId);

    if (!question) return;

    showScreen(
      'rq-question-screen'
    );

    state.currentQuestionId =
      questionId;

    if (
      question.type ===
      'multi_select'
    ) {

      state.selectedOptionId =
        state.answers[
          questionId
        ] || [];

    } else {

      state.selectedOptionId =
        state.answers[
          questionId
        ] || null;

    }

    elements.title.textContent =
      question.title;

    elements.description.textContent =
      question.description;

    updateProgress(questionId);

    if (
      question.type === 'input'
    ) {

      renderInput(question);

    } else {

      renderOptions(question);

    }

    updateButtons();

  }

  /* =====================================================
     RENDER OPTIONS
  ===================================================== */

  function renderOptions(question) {

    elements.options.innerHTML = '';

    question.options.forEach(option => {

      const button =
        document.createElement(
          'button'
        );

      button.type = 'button';

      button.className =
        'rq-option';

      const isSelected =
        Array.isArray(
          state.selectedOptionId
        )

          ? state.selectedOptionId.includes(
              option.id
            )

          : state.selectedOptionId ===
            option.id;

      if (isSelected) {

        button.classList.add(
          'active'
        );

      }

      button.innerHTML = `

        ${
  question.type === 'multi_select'

    ? `
      <div class="rq-option-checkbox"></div>
    `

    : `
      <div class="rq-option-radio"></div>
    `
}

        <div class="rq-option-content">

          <div class="rq-option-title">
            ${option.label}
          </div>

          ${
            option.description
              ? `
              <div class="rq-option-description">
                ${option.description}
              </div>
            `
              : ''
          }

        </div>

      `;

      button.addEventListener(
        'click',
        () => {

          selectOption(
            option.id
          );

        }
      );

      elements.options.appendChild(
        button
      );

    });

  }

  
  function renderInput(question) {

  elements.options.innerHTML = `

    <div class="rq-input-wrapper">

      <input
        type="${
          question.field === 'email'
            ? 'email'
            : 'text'
        }"
        class="rq-input"
        placeholder="${question.placeholder}"
        value="${
          state.answers[
            question.field
          ] || ''
        }"
      />

      <div class="rq-input-error"></div>

    </div>

  `;

  const input =
    document.querySelector(
      '.rq-input'
    );

  const errorEl =
    document.querySelector(
      '.rq-input-error'
    );

  input.addEventListener(
    'input',
    event => {

      const value =
        event.target.value.trim();

      let isValid = true;

      /* =========================
         EMAIL VALIDATION
      ========================= */

      if (
        question.field === 'email'
      ) {

        const emailRegex =
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        isValid =
          emailRegex.test(value);

        if (!isValid && value) {

          errorEl.textContent =
            'Please enter a valid email address';

        } else {

          errorEl.textContent =
            '';

        }

      }

      state.answers[
        question.field
      ] = value;

      state.selectedOptionId =
        isValid && value
          ? value
          : null;

      updateButtons();

    }
  );

}

  /* =====================================================
     SELECT OPTION
  ===================================================== */

  function selectOption(optionId) {

    const currentQuestion =
      getQuestion(
        state.currentQuestionId
      );

    const isMultiSelect =
      currentQuestion.type ===
      'multi_select';

   if (isMultiSelect) {

  let selectedValues =
    state.answers[
      state.currentQuestionId
    ] || [];

  const alreadySelected =
    selectedValues.includes(optionId);

  /* =========================
     NONE SELECTED
  ========================= */

  if (optionId === 'none' || optionId === 'none_meds') {

    if (alreadySelected) {

      selectedValues = [];

    } else {

      selectedValues = [optionId];

    }

  }

  /* =========================
     NORMAL OPTION
  ========================= */

  else {

    // remove none option first
    selectedValues =
      selectedValues.filter(
        value =>
          value !== 'none' &&
          value !== 'none_meds'
      );

    if (alreadySelected) {

      selectedValues =
        selectedValues.filter(
          value =>
            value !== optionId
        );

    } else {

      selectedValues.push(
        optionId
      );

    }

  }

  state.answers[
    state.currentQuestionId
  ] = selectedValues;

  state.answers._lastMultiSelection =
    selectedValues;

  state.selectedOptionId =
    selectedValues;

  renderOptions(currentQuestion);

  updateButtons();

  return;

}

    state.selectedOptionId =
      optionId;

    state.answers[
      state.currentQuestionId
    ] = optionId;

    state.answers._lastSelectedOption =
      optionId;

    const option =
      currentQuestion.options.find(
        o => o.id === optionId
      );

    if (option) {

      if (option.journey) {
        state.answers.journey =
          option.journey;
      }

      if (option.biology) {
        state.answers.biology =
          option.biology;
      }

      if (option.partnerScope) {
        state.answers.partnerScope =
          option.partnerScope;
      }

      if (option.pressureType) {
        state.answers.pressureType =
          option.pressureType;
      }

      if (option.vasectomyType) {
        state.answers.vasectomyType =
          option.vasectomyType;
      }

    }

    document
      .querySelectorAll(
        '.rq-option'
      )
      .forEach(option => {

        option.classList.remove(
          'active'
        );

      });

    const activeIndex =
      currentQuestion.options.findIndex(
        option =>
          option.id === optionId
      );

    document
      .querySelectorAll(
        '.rq-option'
      )
      [activeIndex]
      .classList.add('active');

    updateButtons();

  }

  /* =====================================================
     BUTTONS
  ===================================================== */

  function updateButtons() {

    const currentQuestion =
      getQuestion(
        state.currentQuestionId
      );

    if (
      currentQuestion.type ===
      'input'
    ) {

      elements.nextButton.disabled =
        !state.selectedOptionId;

    }

    else if (
      currentQuestion.type ===
      'multi_select'
    ) {

      const values =
        state.answers[
          state.currentQuestionId
        ] || [];

      elements.nextButton.disabled =
        values.length === 0;

    }

    else {

      elements.nextButton.disabled =
        !state.selectedOptionId;

    }

    elements.backButton.disabled =
      state.history.length === 0;

  }


  /* =====================================================
     SUBMIT QUIZ ANSWERS
  ===================================================== */


  function buildBackendPayload(rec1, rec2) {
  const a = state.answers;
  const payload = {};
  

  // Who is being tested
  if (a.who_testing !== undefined) {
    payload.whoTesting = a.who_testing;
  }

  // Goal
  if (a.male_goal !== undefined) {
    payload.goal = a.male_goal;
  } else if (a.female_goal !== undefined) {
    payload.goal = a.female_goal;
  } else if (a.male_couple_goal !== undefined) {
    payload.goal = a.male_couple_goal;
  } else if (a.female_couple_goal !== undefined) {
    payload.goal = a.female_couple_goal;
  } else if (a.trans_goal !== undefined) {
    payload.goal = a.trans_goal;
  }

  // Who is testing today
  if (a.who_testing_today !== undefined) {
    payload.testingToday = a.who_testing_today;
  }

  // Personal details
  if (a.first_name !== undefined) {
    payload.firstName = a.first_name;
  }

  if (a.age !== undefined) {
    payload.ageRange = a.age;
  }

  // History
  if (a.history !== undefined) {
    payload.history = a.history;
  }

  // Conditions
  if (a.healthDetail !== undefined) {
    payload.conditions = a.healthDetail;
  }

  // Fertility preservation
  if (a.preserving_before !== undefined) {
    payload.preservingBefore = a.preserving_before;
  }

  // Treatment start
  if (a.treatment_start_timeline !== undefined) {
    payload.treatmentStart = a.treatment_start_timeline;
  }

  // HRT start
  if (a.hrt_start_time !== undefined) {
    payload.hrtStart = a.hrt_start_time;
  }

  // Lifestyle
  if (a.lifestyle !== undefined) {
    payload.lifestyleFactors = a.lifestyle;
  }

  // Medications
  if (a.medications !== undefined) {
    payload.medications = a.medications;
  }

  // Vasectomy
  if (a.vasectomy_type !== undefined) {
    payload.vasectomyStatus = a.vasectomy_type;
  }

  // Coverage
  if (a.coverage_question !== undefined) {
    payload.coverage = a.coverage_question;
  }

  // Email
  if (a.email !== undefined) {
    payload.email = a.email;
  }

   // Quiz Recommendations 
if (rec1?.name !== undefined) {
  payload.recommendation1 = rec1.name;
}

if (rec2?.name !== undefined) {
  payload.recommendation2 = rec2.name;
}


  return payload;
}


function showApiToast(message) {
  const toast = document.getElementById('sa-toast');

  if (!toast) return;

  toast.textContent = message;
  toast.classList.add('show');

  setTimeout(() => {
    toast.classList.remove('show');
  }, 4000);
}

async function submitQuizAnswers(quizPayload) {
  

  try {
    const response = await fetch(
      'https://api.sapyenpatientportal.com/api/mysapyen/public/questionnaire',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(quizPayload)
      }
    );

    if (!response.ok) {
      throw new Error(`API failed: ${response.status}`);
    }



    const data = await response.json();
     showApiToast(
      'All done! Your answers have been saved successfully.'
    );

    return {
      success: true,
      data
    };

  } catch (error) {
    console.error('QUIZ SUBMISSION ERROR:', error);
    showApiToast(
      'We couldn’t save your answers, but your recommendation is ready.'
    );

    // Don't break the recommendation flow
    return {
      success: false,
      error
    };
  }
}
  /* =====================================================
     NEXT
  ===================================================== */

function goNext() {

    state.history.push(
      state.currentQuestionId
    );

    const nextQuestionId =
      resolveNext(
        state.currentQuestionId,
        state
      );

    if (!nextQuestionId) return;

    if (
      nextQuestionId ===
      'result'
    ) {
      renderResult();
      return;
    }

    

    renderQuestion(
      nextQuestionId
    );

  }

  /* =====================================================
     BACK
  ===================================================== */

  function goBack() {

    const previousQuestion =
      state.history.pop();

    if (!previousQuestion) return;

    renderQuestion(
      previousQuestion
    );

  }


  /* =====================================================
     SKIP INSURANCE PAGE
  ===================================================== */

function shouldSkipInsurance() {

  return Shopify.country !== 'US';

}

  /* =====================================================
     RESULT
  ===================================================== */

  function renderResult() {


  showScreen(
    'rq-fertility-profile'
  );

  const firstName =
    state.answers.first_name ||
    'there';

  const biology =
    state.answers.biology;

  /* =====================================================
     NAME
  ===================================================== */

  const nameEl =
    document.querySelector(
      '[data-rq-name]'
    );

  if (nameEl) {

    nameEl.textContent =
      firstName;

  }

  /* =====================================================
   FEMALE / FF
===================================================== */

if (
  biology === 'female' ||
  biology === 'ff'
) {

  document.querySelector(
    '[data-rq-estimate-label]'
  ).textContent =
    'Estimated AMH';

  document.querySelector(
    '[data-rq-unit]'
  ).textContent =
    'ng/mL';

   document.querySelector(
    '[data-rq-unit]'
  ).style =
   "font-size:48px";

  document.querySelector(
    '[data-rq-total-unit]'
  ).textContent =
    'ng/mL';

  document.querySelector(
    '[data-rq-total-label]'
  ).textContent =
    'Estimated AMH';

  document.querySelector(
    '[data-rq-breakdown-title]'
  ).textContent =
    'HOW AMH ESTIMATE IS CALCULATED?';

  /* SIGNAL 1 */

  document.querySelector(
    '[data-rq-signal1-title]'
  ).textContent =
    'Ovarian reserve';

  document.querySelector(
    '[data-rq-signal1-desc]'
  ).textContent =
    'Estimated ovarian reserve based on age and fertility history.';

  /* SIGNAL 2 */

  document.querySelector(
    '[data-rq-signal2-title]'
  ).textContent =
    'Hormonal balance';

  document.querySelector(
    '[data-rq-signal2-desc]'
  ).textContent =
    'Lifestyle and weight factors that may affect reproductive hormones.';

  /* SIGNAL 3 */

  document.querySelector(
    '[data-rq-signal3-title]'
  ).textContent =
    'Conception window';

  document.querySelector(
    '[data-rq-signal3-desc]'
  ).textContent =
    'Your current fertility timing based on age range.';

  /* SIGNAL 4 */

  document.querySelector(
    '[data-rq-signal4-title]'
  ).textContent =
    'Recovery potential';

  document.querySelector(
    '[data-rq-signal4-desc]'
  ).textContent =
    'Likelihood of improving fertility through lifestyle changes.';


  const amh =
    getEstimatedAMH(
      state.answers
    );

  const band =
    getAMHBand(amh);

    const amhBaseline =
  AMH_AGE_MEDIAN[
    ageBand(
      state.answers.age
    )
  ] || 2.2;

const hasAMHModifiers =
  [
    ...(state.answers.lifestyle || []),
    ...(state.answers.history || [])
  ].some(
    key => AMH_MODIFIERS[key]
  );

/* =========================================
   DIRECT RECOMMENDATION FLOW
========================================= */

if (
  (
    !hasAMHModifiers &&
    Number(amh.toFixed(2)) ===
      Number(amhBaseline)
  ) ||
  (
    Shopify.country !== 'GB' &&
    (
      biology === 'female' ||
      biology === 'ff'
    )
  )
) {

  renderRecommendationPage();

  return;

}

  /* =========================================
     SCORE
  ========================================= */

  const scoreEl =
    document.querySelector(
      '[data-rq-score]'
    );

  const totalEl =
    document.querySelector(
      '[data-rq-total]'
    );

  if (scoreEl) {

    scoreEl.textContent =
      `${amh.toFixed(2)}`;

  }

  if (totalEl) {

    totalEl.textContent =
      `${amh.toFixed(2)}`;

  }

  /* =========================================
     LABEL
  ========================================= */

  const estimateLabel =
    document.querySelector(
      '.rq-estimate-label'
    );

  if (estimateLabel) {

    estimateLabel.textContent =
      'Estimated AMH';

  }

  /* =========================================
     SIGNAL PILLS
  ========================================= */

  const pills =
    document.querySelectorAll(
      '.rq-pill'
    );

  if (pills[0]) {

    pills[0].textContent =
      AMH_BAND_LABELS[band];

    pills[0].className =
      `rq-pill ${
        band === 'low'
          ? 'warning'
          : band === 'diminished'
          ? 'open'
          : band === 'high'
          ? 'high'
          : 'normal'
      }`;

  }

  /* =========================================
     HORMONAL BALANCE
  ========================================= */

  if (pills[1]) {

    const hasWeightIssue =
      (
        state.answers.lifestyle || []
      ).includes('overweight');

    pills[1].textContent =
      hasWeightIssue
        ? 'WARNING'
        : 'NORMAL';

    pills[1].className =
      `rq-pill ${
        hasWeightIssue
          ? 'warning'
          : 'normal'
      }`;

  }

  /* =========================================
     CONCEPTION WINDOW
  ========================================= */

  if (pills[2]) {

    const ageBandSelected =
      ageBand(state.answers.age);

    let conceptionState =
      'OPEN';

    let conceptionClass =
      'normal';

    if (
      ageBandSelected === '35_39'
    ) {

      conceptionState =
        'WARNING';

      conceptionClass =
        'open';

    }

    if (
      ageBandSelected === '40_44'
    ) {

      conceptionState =
        'TIGHTENING';

      conceptionClass =
        'warning';

    }

    if (
      ageBandSelected === '45_49' ||
      ageBandSelected === '50_plus'
    ) {

      conceptionState =
        'CRITICAL';

      conceptionClass =
        'warning';

    }

    pills[2].textContent =
      conceptionState;

    pills[2].className =
      `rq-pill ${conceptionClass}`;

  }

  /* =========================================
     RECOVERY POTENTIAL
  ========================================= */

  if (pills[3]) {

    let recovery =
      'HIGH';

    let recoveryClass =
      'high';

    if (
      band === 'diminished'
    ) {

      recovery =
        'LOW';

      recoveryClass =
        'warning';

    }

    else if (
      is35Plus(
        ageBand(
          state.answers.age
        )
      )
    ) {

      recovery =
        'WARNING';

      recoveryClass =
        'open';

    }

    pills[3].textContent =
      recovery;

    pills[3].className =
      `rq-pill ${recoveryClass}`;

  }

  /* =========================================
     BREAKDOWN
  ========================================= */

  const breakdown =
    document.querySelector(
      '[data-rq-breakdown]'
    );

  if (breakdown) {

    let rows = '';

    rows += `

      <div class="rq-breakdown-row">

        <span>Age baseline</span>

        <strong>
          ${
            AMH_AGE_MEDIAN[
              ageBand(
                state.answers.age
              )
            ]
          } ng/mL
        </strong>

      </div>

    `;

    [
      ...(state.answers.lifestyle || []),
      ...(state.answers.history || [])
    ].forEach(key => {

      if (!AMH_MODIFIERS[key]) return;

      rows += `

        <div class="rq-breakdown-row">

          <span>
            ${
              key
                .replaceAll('_', ' ')
                .replace(
                  /\b\w/g,
                  c => c.toUpperCase()
                )
            }
          </span>

          <strong>
            ${AMH_MODIFIERS[key]} ng/mL
          </strong>

        </div>

      `;

    });

    rows += `

      <div class="rq-breakdown-row">

        <span>Estimated AMH</span>

        <strong>
          ${amh.toFixed(2)} ng/mL
        </strong>

      </div>

    `;

    breakdown.innerHTML =
      rows;

  }

}

  /* =====================================================
     MALE / MM / TNB
  ===================================================== */

  else {

    const dfi =
      getEstimatedDFI(
        state.answers
      );

    const band =
      getDFIBand(dfi);


    const dfiBaseline =
  DFI_AGE_BASELINE[
    ageBand(
      state.answers.age
    )
  ] || 17;

const hasDFIModifiers =
  [
    ...(state.answers.lifestyle || []),
    ...(state.answers.healthDetail || []),
    ...(state.answers.history || []),
    ...(state.answers.medications || [])
  ].some(
    key => DFI_MODIFIERS[key]
  );

/* =========================================
   DIRECT RECOMMENDATION FLOW
========================================= */

if (
  !hasDFIModifiers &&
  Number(dfi) ===
    Number(dfiBaseline)
) {

  renderRecommendationPage();

  return;

}


      

    /* =========================================
       SCORE
    ========================================= */

    const scoreEl =
      document.querySelector(
        '[data-rq-score]'
      );

    const totalEl =
      document.querySelector(
        '[data-rq-total]'
      );

    if (scoreEl) {
      scoreEl.textContent =
        dfi;
    }

    if (totalEl) {
      totalEl.textContent =
        dfi;
    }

    /* =========================================
       MAIN WARNING PILL
    ========================================= */

    const warningPill =
      document.querySelector(
        '.rq-signal-row .rq-pill'
      );

    if (warningPill) {

      warningPill.textContent =
        band.toUpperCase();

      warningPill.className =
        `rq-pill ${
          band === 'critical'
            ? 'warning'
            : band === 'significant'
            ? 'warning'
            : band === 'mild'
            ? 'open'
            : 'normal'
        }`;

    }

    /* =========================================
       HORMONE DISRUPTION
    ========================================= */

    const hormonePill =
      document.querySelectorAll(
        '.rq-signal-row .rq-pill'
      )[1];

    const meds =
      state.answers.medications || [];

    const hasHormoneIssue =
      meds.includes('trt') ||
      meds.includes('chemo');

    if (hormonePill) {

      hormonePill.textContent =
        hasHormoneIssue
          ? 'DISRUPTED'
          : 'NORMAL';

      hormonePill.className =
        `rq-pill ${
          hasHormoneIssue
            ? 'warning'
            : 'normal'
        }`;

    }

    /* =========================================
       CONCEPTION WINDOW
    ========================================= */

    const conceptionPill =
      document.querySelectorAll(
        '.rq-signal-row .rq-pill'
      )[2];

    if (conceptionPill) {

      conceptionPill.textContent =
        +state.answers.age >= 40
          ? 'NARROWING'
          : 'OPEN';

      conceptionPill.className =
        `rq-pill ${
          +state.answers.age >= 40
            ? 'warning'
            : 'open'
        }`;

    }

    /* =========================================
       RECOVERY POTENTIAL
    ========================================= */

    const recoveryPill =
      document.querySelectorAll(
        '.rq-signal-row .rq-pill'
      )[3];

    const lifestyleCount =
      (
        state.answers.lifestyle || []
      ).filter(
        x => x !== 'none'
      ).length;

    if (recoveryPill) {

      recoveryPill.textContent =
        lifestyleCount >= 3
          ? 'HIGH'
          : lifestyleCount >= 1
          ? 'MEDIUM'
          : 'LOW';

      recoveryPill.className =
        `rq-pill ${
          lifestyleCount >= 3
            ? 'high'
            : lifestyleCount >= 1
            ? 'open'
            : 'normal'
        }`;

    }

    /* =========================================
       BREAKDOWN
    ========================================= */

    const breakdown =
      document.querySelector(
        '[data-rq-breakdown]'
      );

    if (breakdown) {

      let rows = '';

      rows += `

        <div class="rq-breakdown-row">
          <span>Age baseline</span>
          <span>
            ${
              DFI_AGE_BASELINE[
                ageBand(
                  state.answers.age
                )
              ]
            }%
          </span>
          
        </div>

      `;

      [
        ...(state.answers.lifestyle || []),
        ...(state.answers.healthDetail || []),
        ...(state.answers.history || []),
        ...(state.answers.medications || [])
      ].forEach(key => {

        if (!DFI_MODIFIERS[key]) return;

        rows += `

          <div class="rq-breakdown-row">

            <span>
              ${
                key
                  .replaceAll('_', ' ')
                  .replace(
                    /\b\w/g,
                    c => c.toUpperCase()
                  )
              }
            </span>

            <span>
              +${DFI_MODIFIERS[key]}%
            </span>

          </div>

        `;

      });

      breakdown.innerHTML =
        rows;

    }

  }

  /* =====================================================
     CTA BUTTON
  ===================================================== */

  const recommendationButton =
    document.getElementById(
      'rq-view-recommendation'
    );

  if (recommendationButton) {

    recommendationButton.onclick =
      renderRecommendationPage;

  }

}



async function renderRecommendationPage() {

  showScreen(
    'rq-recommendation-page'
  );

  const firstName =
    state.answers.first_name ||
    'there';

  const primaryKey =
    getPrimaryProduct(
      state.answers
    );

  const partnerKey =
    getPartnerProduct(
      state.answers
    );

  const primary =
    PRODUCTS[primaryKey];

  const partner =
    PRODUCTS[partnerKey];


  /* =====================================
     NAME
  ===================================== */

  const nameEl =
    document.querySelector(
      '[data-rq-rec-name]'
    );

  if (nameEl) {

    nameEl.textContent =
      firstName;

  }

  /* =====================================
     PRIMARY PRODUCT
  ===================================== */

  document.querySelector(
    '.rq-rec-title'
  ).textContent =
    primary?.shortTitle;

  document.querySelector(
    '.rq-rec-desc'
  ).innerHTML =
    primary?.description;

  document.querySelector(
    '.rq-rec-copy'
  ).innerHTML = `

    <strong>
      Why we recommend this for you:
    </strong>

    ${primary.why}

  `;

  document.querySelector(
    '.rq-product-title'
  ).textContent =
    primary?.name;

  document.querySelector(
    '.rq-price-main'
  ).textContent =
    primary?.price;

  document.querySelector(
    '.rq-price-old'
  ).textContent =
    primary?.comparePrice;

  document.querySelector(
    '.rq-product-image img'
  ).src =
    primary?.image;
    

  const featureList =
    document.querySelector(
      '.rq-product-list'
    );

  featureList.innerHTML =
    primary.features
      .map(
        feature =>
          `<li>${feature}</li>`
      )
      .join('');

  /* =====================================
     PARTNER / UNAVAILABLE FLOW
  ===================================== */

  const partnerSection =
    document.getElementById(
      'rq-partner-section'
    );

  const unavailableSection =
    document.getElementById(
      'rq-partner-unavailable'
    );

  const recommendationGrid =
    document.querySelector(
      '.rq-recommendation-grid'
    );

  /* =====================================
     FF PATH
     Hide everything and show unavailable
  ===================================== */

  if (
    state.answers.biology === 'ff' &&
    Shopify.country !== 'GB'
  ) {

    if (recommendationGrid) {

      recommendationGrid.style.display =
        'none';

    }

    if (partnerSection) {

      partnerSection.style.display =
        'none';

    }

    if (unavailableSection) {

      unavailableSection.style.display =
        'block';

    }

  /* =====================================
     FEMALE PATH
     Hide primary recommendation
     Show unavailable + partner recommendation
  ===================================== */

  } else if (
    state.answers.biology === 'female' &&
    Shopify.country !== 'GB'
  ) {

    if (recommendationGrid) {

      recommendationGrid.style.display =
        'none';

    }

    if (unavailableSection) {

      unavailableSection.style.display =
        'block';

    }

    if (
      partner &&
      partnerSection
    ) {

      partnerSection.style.display =
        'block';

      document.querySelector(
        '.rq-partner-heading'
      ).textContent =
        'Recommendation for your partner';

      const partnerTitleEls =
        document.querySelectorAll(
          '#rq-partner-section .rq-rec-title'
        );

      partnerTitleEls.forEach(el => {

        el.textContent =
          partner.shortTitle;

      });

      const partnerDescEls =
        document.querySelectorAll(
          '#rq-partner-section .rq-rec-desc'
        );

      partnerDescEls.forEach(el => {

        el.innerHTML =
          partner.description;

      });

      document.querySelector(
        '#rq-partner-section .rq-product-title'
      ).textContent =
        partner.name;

      document.querySelector(
        '#rq-partner-section .rq-price-main'
      ).textContent =
        partner.price;

      document.querySelector(
        '#rq-partner-section .rq-price-old'
      ).textContent =
        partner.comparePrice;

      document.querySelector(
        '#rq-partner-section .rq-product-image img'
      ).src =
        partner.image;

      const partnerFeatures =
        document.querySelector(
          '#rq-partner-section .rq-product-list'
        );

      partnerFeatures.innerHTML =
        partner.features
          .map(
            feature =>
              `<li>${feature}</li>`
          )
          .join('');

    }

  /* =====================================
     NORMAL PARTNER FLOW
  ===================================== */

  } else if (
    partner &&
    partnerSection
  ) {

    partnerSection.style.display =
      'none';

    document.querySelector(
      '.rq-partner-heading'
    ).textContent =
      'Recommendation for your partner';

    const partnerTitleEls =
      document.querySelectorAll(
        '#rq-partner-section .rq-rec-title'
      );

    partnerTitleEls.forEach(el => {

      el.textContent =
        partner.shortTitle;

    });

    const partnerDescEls =
      document.querySelectorAll(
        '#rq-partner-section .rq-rec-desc'
      );

    partnerDescEls.forEach(el => {

      el.textContent =
        partner.description;

    });

    document.querySelector(
      '#rq-partner-section .rq-product-title'
    ).textContent =
      partner.name;

    document.querySelector(
      '#rq-partner-section .rq-price-main'
    ).textContent =
      partner.price;

    document.querySelector(
      '#rq-partner-section .rq-price-old'
    ).textContent =
      partner.comparePrice;

    document.querySelector(
      '#rq-partner-section .rq-product-image img'
    ).src =
      partner.image;

    const partnerFeatures =
      document.querySelector(
        '#rq-partner-section .rq-product-list'
      );

    partnerFeatures.innerHTML =
      partner.features
        .map(
          feature =>
            `<li>${feature}</li>`
        )
        .join('');

  }

  /* =====================================
     BUTTON FLOW
  ===================================== */

  const buyButton =
    document.querySelector(
      '.rq-buy-btn'
    );

  if (buyButton) {

    buyButton.onclick =
      async () => {

        /* =========================
           ADD PRIMARY PRODUCT
        ========================= */

        if (
          !state.cart.includes(
            primary.product_id
          )
        ) {

          state.cart.push(
            primary.product_id
          );

        }

        /* =========================
           PARTNER FLOW
        ========================= */

        if (
          partner &&
          partnerSection &&
          state.answers.biology !==
            'female'
        ) {

          partnerSection.style.display =
            'block';

          return;

        }

        /* =========================
           CRYO FLOW
        ========================= */

        if (
          getShowCryo(
            state.answers
          )
        ) {

          renderCryoPage();

          return;

        }

        /* =========================
           DIRECT CART FLOW
        ========================= */

        try {

          showLoader();

          const cartItems =
            state.cart.map(
              item => ({
                id: item,
                quantity: 1
              })
            );

          const addResponse =
            await fetch(
              '/cart/add.js',
              {
                method: 'POST',
                headers: {
                  'Content-Type':
                    'application/json'
                },
                body: JSON.stringify({
                  items: cartItems
                })
              }
            );

          if (
            !addResponse.ok
          ) {

            throw new Error(
              'Failed to add items to cart'
            );

          }

          window.location.href =
            '/cart';

        } catch (err) {

          console.error(err);

        } finally {

          hideLoader();

        }

      };

  }

  /* =====================================
     PARTNER ADD BUTTON
  ===================================== */

  const partnerAddButton =
    document.querySelector(
      '#rq-partner-section .rq-buy-btn'
    );

  if (partnerAddButton) {

    partnerAddButton.onclick =
      async () => {

        /* =========================
           ADD PARTNER PRODUCT
        ========================= */

        // if (
        //   partner &&
        //   !state.cart.includes(
        //     partner.product_id
        //   )
        // ) {

        //   state.cart.push(
        //     partner.product_id
        //   );

        // }

         state.cart.push(
            partner.product_id
          );


        /* =========================
           CRYO FLOW
        ========================= */

        if (
          getShowCryo(
            state.answers
          )
        ) {

          renderCryoPage();

          return;

        }

        /* =========================
           DIRECT CART FLOW
        ========================= */

        try {

          showLoader();

          const cartItems =
            state.cart.map(
              item => ({
                id: item,
                quantity: 1
              })
            );

          const addResponse =
            await fetch(
              '/cart/add.js',
              {
                method: 'POST',
                headers: {
                  'Content-Type':
                    'application/json'
                },
                body: JSON.stringify({
                  items: cartItems
                })
              }
            );

          if (
            !addResponse.ok
          ) {

            throw new Error(
              'Failed to add items to cart'
            );

          }

          window.location.href =
            '/cart';

        } catch (err) {

          console.error(err);

        } finally {

          hideLoader();

        }

      };

  }

  /* =====================================
     PARTNER SKIP BUTTON
  ===================================== */

  const partnerSkipButton =
    document.querySelector(
      '#rq-partner-section .rq-secondary-btn'
    );

  if (partnerSkipButton) {

    partnerSkipButton.onclick =
      async () => {

        /* =========================
           CRYO FLOW
        ========================= */

        if (
          getShowCryo(
            state.answers
          )
        ) {

          renderCryoPage();

          return;

        }

        /* =========================
           DIRECT CART FLOW
        ========================= */

        try {

          showLoader();

          const cartItems =
            state.cart.map(
              item => ({
                id: item,
                quantity: 1
              })
            );

          const addResponse =
            await fetch(
              '/cart/add.js',
              {
                method: 'POST',
                headers: {
                  'Content-Type':
                    'application/json'
                },
                body: JSON.stringify({
                  items: cartItems
                })
              }
            );

          if (
            !addResponse.ok
          ) {

            throw new Error(
              'Failed to add items to cart'
            );

          }

          window.location.href =
            '/cart';

        } catch (err) {

          console.error(err);

        } finally {

          hideLoader();

        }

      };

  }

    /* =====================================
     SUBMIT QUIZ ANSWERS
     ===================================== */
  
  const payload = buildBackendPayload(primary, partner);

  const submissionResult = await submitQuizAnswers(payload);

  if (!submissionResult.success) {
    console.error(
      'Recommendation rendered, but answers could not be saved:',
      submissionResult.error
    );
  }

}



async function renderCryoPage() {

  showScreen('rq-cryo-page');

    
const isMaleCouple =
  state.answers.biology === 'mm' &&
  (state.answers.partnerScope === 'both' || state.answers.partnerScope === 'show_both');


if(isMaleCouple){
document.querySelector(
        '.cryo-total-cost'
      ).textContent =
        '2 (for you and your partner)';

document.querySelector(
        '.cryo-total-cost-button'
      ).textContent =
        '1 (each)';
    }

  const addCryoButton = document.querySelector('[data-rq-add-cryo]');
  const skipCryoButton = document.querySelector('[data-rq-skip-cryo]');
  const checkbox = document.querySelector('#rq-cryo-agree');



  

  /* =========================
      RESET STATE
  ========================= */

  if (checkbox) {
    checkbox.checked = false;
  }

  if (addCryoButton) {
    addCryoButton.disabled = true;
  }

  /* =========================
      ENABLE BUTTON
  ========================= */

  if (checkbox && addCryoButton) {

    checkbox.addEventListener('change', () => {
      addCryoButton.disabled = !checkbox.checked;
    });

  }

  /* =========================
      ADD CRYO + STRIPE FLOW
  ========================= */

  if (addCryoButton) {

    addCryoButton.onclick = async () => {

      if (!checkbox?.checked) return;

      try {


        addCryoButton.disabled = true;

        showLoader();

        /* =========================
            BUILD PAYLOAD
        ========================= */

const itemCounts = state.cart.reduce((acc, id) => {
  acc[id] = (acc[id] || 0) + 1;
  return acc;
}, {});

const stripeItems = await Promise.all(
  Object.entries(itemCounts).map(async ([item, qty]) => {

    const response = await fetch(`/variants/${item}.js`);
    const variant = await response.json();

    return {
      id: Number(item),
      qty,
      sku: variant?.sku?.toLowerCase() || ''
    };
  })
);

        /* =========================
            GET UPDATED CART
        ========================= */

        const cartResponse = await fetch('/cart.js');

        if (!cartResponse.ok) {
          throw new Error('Failed to fetch Shopify cart');
        }

        const cart = await cartResponse.json();


        /* =========================
            MAP CART ITEMS
        ========================= */

        const cartItems = cart.items.map(item => ({
          id: item.id,
          qty: item.quantity,
          sku: item?.sku?.toLowerCase(),
        }));

      // Fetch sperm freezing products
        const cryo_handle = 'upgrade-add-sperm-freezing';
        const cryo_response = await fetch(`/products/${cryo_handle}.js`);
        const cryo_product = await cryo_response.json();
        const cryo_id = cryo_product?.variants[0].id;
        const cryo_sku = cryo_product?.variants[0].sku?.toLowerCase();

        const purchaseItems = stripeItems.map(item => ({
            id: item.id,
            sku: item?.sku?.toLowerCase(),
            qty: item.qty,
            cryo: true,
            cryoQty: 1,
          }));



        /* =========================
            CREATE STRIPE SESSION
        ========================= */

        const response = await fetch(
          'https://api.sapyen.co/api/payments/create-checkout-session',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': '019df253-e564-7c88-9be6-786af0800aa6' 
              //  'x-api-key':'super_secret_key',
            },
            body: JSON.stringify({
                currency: cart?.currency?.toLowerCase() || 'usd',
                purchases: [
                  {
                    purchaseType: 'oneTime',
                    items: purchaseItems,
                  },
                ],
              }),
    //            body: JSON.stringify({
    //           "cart":[...cartItems],
    // "cryo":[
    //     ...stripeItems,
    //     {"id":cryo_id , "qty":isMaleCouple? 2 : 1 , "sku":cryo_sku}
    // ],
    // "currency":cart?.currency || 'usd'
    //         })
            // headers: {
            //   'Content-Type': 'application/json',
            //   'x-api-key': '019df253-e564-7c88-9be6-786af0800aa6'
            // },
            // body: JSON.stringify({
            //   items: [...cartItems],
            //   upgradeCryo: true,
            //   currency: cart.currency || 'usd'
            // })
          }
        );

        if (!response.ok) {
          throw new Error('Stripe checkout session failed');
        }

        const data = await response.json();


        /* =========================
            REDIRECT TO STRIPE
        ========================= */

        if (data?.checkout?.url) {

          window.location.href = data.checkout.url;

        } else {

          throw new Error('Stripe checkout URL missing');

        }

      } catch (error) {

        console.error('CRYO FLOW ERROR:', error);

      } finally {

        hideLoader();

        addCryoButton.disabled = false;


      }

    };

  }

  /* =========================
      SKIP → SHOPIFY CHECKOUT
  ========================= */

  if (skipCryoButton) {

    skipCryoButton.onclick = async () => {

      try {

        skipCryoButton.disabled = true;

 


        /* =========================
            BUILD KIT PAYLOAD
        ========================= */

         const cartItems = state.cart.map(item => ({
  id: item,
  quantity: 1
}));

        /* =========================
            RESET SHOPIFY CART
        ========================= */


        /* =========================
            ADD ONLY KIT PRODUCTS
        ========================= */

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items:[
              ...cartItems
            ]
          })
        });

        if (!addResponse.ok) {
          throw new Error('Failed to add kit items');
        }

        /* =========================
            GO TO SHOPIFY CHECKOUT
        ========================= */

        window.location.href = '/checkout';

      } catch (error) {

        console.error('SHOPIFY CHECKOUT ERROR:', error);

      } finally {

        skipCryoButton.disabled = false;


      }

    };

  }

}

  /* =====================================================
     EVENTS
  ===================================================== */

  elements.nextButton.addEventListener(
    'click',
    goNext
  );

  elements.backButton.addEventListener(
    'click',
    goBack
  );

  /* =====================================================
     INIT
  ===================================================== */

  renderQuestion(
    QUIZ_FLOW.startQuestion
  );

});